import { useMedplum } from '@medplum/react';
import type { Consent } from '@medplum/fhirtypes';
import { useCallback, useEffect, useState } from 'react';
import { CONSENT_CATEGORY_SYSTEM, ROI_CONSENT_CATEGORY_CODE } from '@unify/fhir-model/constants';

export function usePatientRoiConsents(patientId: string | undefined): {
  consents: Consent[];
  loading: boolean;
  refresh: () => Promise<void>;
} {
  const medplum = useMedplum();
  const [consents, setConsents] = useState<Consent[]>([]);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!patientId) {
      setConsents([]);
      return;
    }
    setLoading(true);
    try {
      const results = await medplum.searchResources('Consent', {
        patient: `Patient/${patientId}`,
        'category:code': `${CONSENT_CATEGORY_SYSTEM}|${ROI_CONSENT_CATEGORY_CODE}`,
        _sort: '-_lastUpdated',
        _count: '50',
      });
      setConsents(results);
    } catch {
      setConsents([]);
    } finally {
      setLoading(false);
    }
  }, [medplum, patientId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { consents, loading, refresh };
}
